import React from 'react';
import { simboloMoneda } from '../services/negocioActual';
import { iconoCategoria, obtenerFotoPrincipal } from '../utils/categorias';
import { useCategorias } from '../context/CategoriasContext';
import { enOferta, precioEfectivo, pctOferta } from '../utils/precios';
import { optimizarFoto } from '../utils/imagen';
import { getUmbralStock } from '../utils/stockBajo';
import { formatoCantidad } from '../utils/unidades';

// onCompartir: botón 📤 para mandar la pieza por WhatsApp, Instagram, Facebook…
export default function ProductoCard({ producto, onClick, onCompartir = null }) {
  const { categorias } = useCategorias();
  const foto = obtenerFotoPrincipal(producto);
  const agotado = !((producto.stock || 0) > 0);
  const stockBajo = !agotado && producto.stock <= getUmbralStock();
  return (
    <div onClick={onClick} className={`k-prod${agotado ? ' agotado' : ''}`}>
      <div className="k-prod-img">
        {foto
          ? <img src={optimizarFoto(foto, 450)} alt={producto.nombre} loading="lazy" style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: '8px', filter: agotado ? 'grayscale(70%)' : 'none' }} />
          : <span style={{ fontSize: '48px' }}>{iconoCategoria(categorias, producto.categoria)}</span>
        }
        {agotado && (
          <span style={{ position: 'absolute', top: '8px', left: '8px', backgroundColor: '#DC2626', color: 'white', fontSize: '11px', fontWeight: 'bold', padding: '3px 8px', borderRadius: '999px' }}>
            ✔ Vendido
          </span>
        )}
        {producto.activo === false && (
          <span title="Tus clientas no lo ven en el catálogo en línea" style={{ position: 'absolute', bottom: '8px', left: '8px', backgroundColor: 'rgba(31,26,46,.85)', color: 'white', fontSize: '11px', fontWeight: 'bold', padding: '3px 8px', borderRadius: '999px' }}>
            🙈 Oculto del catálogo
          </span>
        )}
        {onCompartir && (
          <button type="button" title="Compartir este producto" aria-label={`Compartir ${producto.nombre}`}
            onClick={(e) => { e.stopPropagation(); onCompartir(producto); }}
            style={{ position: 'absolute', top: '8px', right: '8px', width: '36px', height: '36px', borderRadius: '50%', border: '1px solid #ECE8F6', background: 'rgba(255,255,255,.95)', boxShadow: '0 2px 8px rgba(28,24,48,.12)', cursor: 'pointer', fontSize: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            📤
          </button>
        )}
      </div>
      <p style={{ margin: '0 0 4px', fontWeight: 'bold', fontSize: '14px', color: '#111827' }}>{producto.nombre}</p>
      {producto.codigo && (
        <span style={{ display: 'inline-block', margin: '0 0 4px', fontSize: '11px', fontWeight: 700, color: 'var(--color-primario,#DB2777)', backgroundColor: 'color-mix(in srgb, var(--color-primario,#DB2777) 10%, white)', border: '1px solid color-mix(in srgb, var(--color-primario,#DB2777) 28%, white)', padding: '1px 7px', borderRadius: '6px', letterSpacing: '0.3px' }}>
          {producto.codigo}
        </span>
      )}
      {producto.marca && <p style={{ margin: '0 0 4px', fontSize: '12px', color: '#6B7280' }}>{producto.marca}</p>}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '8px' }}>
        {enOferta(producto) ? (
          <span>
            <span style={{ fontSize: '12px', color: '#9CA3AF', textDecoration: 'line-through', marginRight: '5px' }}>{simboloMoneda()} {producto.precio_venta}</span>
            <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#EA580C' }}>{simboloMoneda()} {precioEfectivo(producto)}</span>
            <span style={{ display: 'inline-block', marginLeft: '4px', fontSize: '9px', fontWeight: 700, color: 'white', backgroundColor: '#EA580C', padding: '1px 5px', borderRadius: '4px' }}>-{pctOferta(producto)}%</span>
          </span>
        ) : (
          <span style={{ fontSize: '16px', fontWeight: 'bold', color: 'var(--color-primario,#DB2777)' }}>{simboloMoneda()} {producto.precio_venta}</span>
        )}
        <span style={{ fontSize: '12px', backgroundColor: agotado ? '#FEE2E2' : stockBajo ? '#FEF3C7' : '#D1FAE5', color: agotado ? '#DC2626' : stockBajo ? '#92400E' : 'var(--k-verde)', padding: '2px 8px', borderRadius: '999px', fontWeight: 600 }}>
          {agotado ? 'Vendido' : `Stock: ${formatoCantidad(producto.stock, producto)}`}
        </span>
      </div>
      {producto.talla && <p style={{ margin: '4px 0 0', fontSize: '12px', color: '#9CA3AF' }}>Talla: {producto.talla} {producto.color && `· ${producto.color}`}</p>}
    </div>
  );
}
